import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import styles from './VideoBubble.scss';
import { Box, IconButton } from 'wix-style-react';
import withAppMode from '../../../providers/appMode/withAppMode';
import withOnVideoMessageClick from '../../../providers/ChatConfiguration/withOnVideoMessageClick';
import PlayFilled from 'wix-ui-icons-common/PlayFilled';
import StatusAlert from 'wix-ui-icons-common/StatusAlert';
import { withTranslation } from 'react-i18next';
import { withErrorBoundary } from '../../ErrorBoundary/ErrorBoundary';
var VideoBubble = /** @class */ (function (_super) {
    __extends(VideoBubble, _super);
    function VideoBubble(props) {
        var _this = _super.call(this, props) || this;
        _this.handleVideoError = function () {
            _this.setState({ hasError: true });
        };
        _this.handleVideoLoad = function () {
            _this.setState({ isLoading: false });
        };
        _this.handleVideoClick = function (onClick) { return function () {
            var uri = _this.props.messagePart.data.uri;
            onClick === null || onClick === void 0 ? void 0 : onClick({
                url: uri,
            });
        }; };
        _this.state = {
            isLoading: true,
            hasError: false,
        };
        return _this;
    }
    VideoBubble.prototype.render = function () {
        var _a;
        var _b = this.props, messagePart = _b.messagePart, transit = _b.transit, t = _b.t, onVideoMessageClick = _b.onVideoMessageClick;
        var _c = this.state, isLoading = _c.isLoading, hasError = _c.hasError;
        var isPending = transit && transit.isPending;
        var src = messagePart.data.uri;
        return hasError ? (React.createElement(Box, { direction: "vertical", verticalAlign: "middle", className: styles.videoError, dataHook: "video-error-container" },
            React.createElement(StatusAlert, null),
            React.createElement("span", { className: styles.errorText }, t('this.content.is.unavailable')))) : (React.createElement("div", { onClick: this.handleVideoClick(onVideoMessageClick), "data-hook": "video-container", role: "button", tabIndex: -1, className: styles.videoWrapper, style: { background: '#000624' } },
            React.createElement("video", { "data-hook": "video-message", src: src, onLoadedData: this.handleVideoLoad, onError: this.handleVideoError, className: classnames((_a = {},
                    _a[styles.video] = true,
                    _a[styles.videoLoading] = isLoading,
                    _a)), style: {
                    maxWidth: '252px',
                    background: '#000624',
                    maxHeight: '252px',
                } }),
            !isPending && !isLoading && !hasError ? (React.createElement("div", { className: styles.iconsWrapper },
                React.createElement(IconButton, { as: "button", skin: "light", dataHook: "play-icon" },
                    React.createElement(PlayFilled, null)))) : null,
            (isPending || isLoading) && !hasError ? (React.createElement("div", { "data-hook": "loader", className: styles.pending },
                React.createElement("div", { className: styles.loader }))) : null));
    };
    return VideoBubble;
}(React.Component));
export default withErrorBoundary('Video Player', withOnVideoMessageClick(withAppMode(withTranslation()(VideoBubble))));
//# sourceMappingURL=VideoBubble.js.map